import { render, staticRenderFns } from "./PersonPickerDemo.vue?vue&type=template&id=c9abfe14"
import script from "./PersonPickerDemo.vue?vue&type=script&lang=js"
export * from "./PersonPickerDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports